import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";
import i18n, { DEFAULT_LANG } from "./lib/i18n"; // inicializa i18next antes de renderizar la app
import AuthProvider from "./lib/AuthProvider";
import { primeCommercialOffer } from "./hooks/useCommercialOffer";
import { preloadNotFound, preloadPublicRoute } from "./Routes";

const container = document.getElementById("root");

// Oferta con la que se prerenderizó la página (scripts/prerender.mjs): el primer render tiene que usar los
// mismos precios que el HTML, o la hidratación no coincide. Se revalida contra la base después.
primeCommercialOffer(window.__INITIAL_OFFER__);

const tree = (
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

// Ruta pública prerenderizada (scripts/prerender.mjs): el HTML se generó en español. Sólo se hidrata si
// el visitante también arranca en español, para que el primer render coincida con el HTML. Quien detecta
// otro idioma renderiza desde cero (como antes del prerender): cambiar el idioma después de hidratar
// compite con la hidratación de los chunks lazy y deja la página a medio coincidir.
const prerendered = container.hasAttribute("data-prerendered");
// `language` conserva la región detectada ("es-UY"); el idioma efectivo es el normalizado.
const startsInDefaultLang = (i18n.resolvedLanguage || i18n.language || "").split("-")[0] === DEFAULT_LANG;
if (prerendered && startsInDefaultLang) {
  // Se hidrata recién con el chunk de la página ya cargado (el HTML prerenderizado ya está a la vista, así que
  // no se espera "en blanco"): ver PUBLIC_PAGE_IMPORTERS en Routes.jsx. `preloadPublicRoute` nunca rechaza.
  // build/404.html (Vercel lo sirve en CUALQUIER URL inexistente) trae data-prerendered="404": ahí el chunk a
  // precargar es el de la página 404, no el de la ruta de la URL.
  const preload = container.getAttribute("data-prerendered") === "404" ? preloadNotFound() : preloadPublicRoute(window.location.pathname);
  preload.then(() => {
    hydrateRoot(container, tree, {
      onRecoverableError: (error) => console.warn("[hydration]", error),
    });
  });
} else {
  if (prerendered) container.removeAttribute("data-prerendered");
  createRoot(container).render(tree);
}
